import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes } from 'react';

type PillProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export default function Pill({
  className,
  children,
  ...props
}: PillProps) {

  return (
    <div
      className={classNames(
        '[&>*:first-child]:rounded-r-none',
        '[&>*:last-child]:rounded-l-none',
        '[&>*:not(:first-child)]:border-l-0',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
